import { render } from "./AppBlocked.vue?vue&type=template&id=c2d30704&ts=true"
import script from "./AppBlocked.vue?vue&type=script&lang=ts"
export * from "./AppBlocked.vue?vue&type=script&lang=ts"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__